/**
 * Created by olga on 10.07.2026
 */

const ScissorsComponent = function (unit, options) {
    UnitComponent.call(this, unit);

    this.charges = options.charges || unit.getData().scissors.charges;
};

ScissorsComponent.prototype = Object.create(UnitComponent.prototype);
ScissorsComponent.prototype.constructor = ScissorsComponent;

ScissorsComponent.prototype.save = function (data) {
    data.charges = this.charges;
};

ScissorsComponent.prototype.handleDragMove = function (rawX, rawY, handled) {
    const affected = handled ? undefined : this.findAffectedUnit(rawX, rawY, true);

    if (affected !== this.highlightedTarget) {
        this.unhighlightTarget();

        if (affected) {
            this.highlightedTarget = affected;
            affected.findComponent(MergeComponent).startMergeHighlight();
        }
    }

    return Boolean(affected);
};

ScissorsComponent.prototype.unhighlightTarget = function () {
    const target = this.highlightedTarget;
    this.highlightedTarget = undefined;

    if (target) {
        target.findComponent(MergeComponent).stopHighlight();
    }
};

ScissorsComponent.prototype.handleDragEnd = function (rawX, rawY, cancelled) {
    this.unHighlightDrag();
    this.unhighlightTarget();

    const affected = this.findAffectedUnit(rawX, rawY, cancelled);

    if (affected && !cancelled) {
        if (this.hasSpaceToCut(affected)) {
            this.cut(affected);
        } else {
            Merge2.current.showNoSpaceHint(this.unit.onGetView());
        }

        this.unit.resetDrag();
        return true;
    }
};

ScissorsComponent.prototype.hasSpaceToCut = function (target) {
    return Boolean(Merge2.current.field.findEmptySlot(target.x, target.y));
};

ScissorsComponent.prototype.isAffectedUnit = function (unit) {
    return this.isCuttable(unit);
};

ScissorsComponent.prototype.onWrongTarget = function () {
    Merge2.current.showHint(this.unit.onGetView(), Messages.get("Scissors.wrongTarget"));
};

ScissorsComponent.prototype.isMergeable = function (unit) {
    return Boolean(unit.findComponent(ScissorsComponent));
};

ScissorsComponent.prototype.mergeUnit = function (affectedUnits) {
    return {
        code: this.unit.code,
        stage: this.unit.stage,
        charges: affectedUnits.reduce((charges, unit) => charges + unit.findComponent(ScissorsComponent).charges, 0)
    };
};

ScissorsComponent.prototype.handleRemove = function () {
    this.unHighlightDrag();
    this.unhighlightTarget();
};

ScissorsComponent.prototype.destructor = function () {
    this.unHighlightDrag();
    this.unhighlightTarget();
};

ScissorsComponent.prototype.handleDragStart = function () {
    if (this.view) {
        this.view.highlightDrag();
    }
};

ScissorsComponent.prototype.unHighlightDrag = function () {
    if (this.view) {
        this.view.unHighlightDrag();
    }
};

ScissorsComponent.prototype.cut = function (target) {
    const targetCell = { x: target.x, y: target.y };
    const stage = target.stage - 1;

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.BOOSTER_USE}-${this.unit.code}`, { itemId: target.getType() });
    cleverapps.playSession.logEventOnce(`${cleverapps.EVENTS.BOOSTER_USE_DAU}-${this.unit.code}`);

    target.onDestruction();
    target.remove(true);
    this.spendCharge();

    Merge2.current.spawn([{ code: target.code, stage }, { code: target.code, stage }], targetCell, {
        targetCell,
        delay: 300
    });
};

ScissorsComponent.prototype.spendCharge = function () {
    this.charges -= 1;

    if (this.charges > 0) {
        this.unit.save();
        return;
    }

    this.unit.onDestruction();
    this.unit.remove(true);
};

ScissorsComponent.prototype.isCuttable = function (unit) {
    return unit.stage > 0 && (!unit.getData().unmergeable || unit.getType() === "generator" || unit.code === "hg") && !unit.findComponent(ScissorsComponent)
        && !Unit.isSideQuest(unit.code) && unit.getType() !== "energycup" && !unit.isGrounded();
};
